module.exports = __webpack_public_path__ + "static/media/sidebar-8-3.097a9495.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sidebar-8-3.jpg
// module id = 1459
// module chunks = 0